import * as yup from 'yup';
import i18n from 'i18n';
import {string} from './customs/string';

export const BIG_TEXT_SIZE = 50;
export const FILE_LOC_SIZE = 55;
export const INT_TEXT_SIZE = 5;
export const PASSWORD_SIZE = 25;
export const SMALL_TEXT_SIZE = 12;
export const SPACER = 5;
export const TEXT_SIZE = 25;
export const CHAR_64_SIZE = 55;
export const CHAR_120_SIZE = 88;

export * from 'yup';
export {idString} from './customs/idString';
export {string} from './customs/string';
export {date} from './customs/date';
export {localDate} from './customs/localDate';
export {localTime} from './customs/localTime';

yup.setLocale({mixed: {required: i18n.t('This field is required')}});
export const yup64String = () => yup.string().max(CHAR_64_SIZE);

//TODO remove
export const nullableString = () => yup.string().nullable();

export const originString = () => yup.string();
export const hexString = string;
//  () =>
//    string().transform((val, origin) => {
//       return base64ToHexString(origin);
// });
export const url = string;

export const originArray = yup.array;
export const array = () => yup.array().ensure();

export const dateString = string;
export const originDate = yup.date;
export const nullableDate = () => yup.date().nullable();

/**
 * override default cast method to not throw errors;
 */
const cast = yup.mixed.prototype.cast;
yup.mixed.prototype.cast = function (value: any, options: any = {}) {
   try {
      return cast.call(this, value, options);
   } catch (e) {
      console.error(e);
      return cast.call(this, value, {assert: false, ...options});
   }
};
